import React from 'react';
import { Col } from 'antd';

import { InfoProprietario } from '../InfoProprietario/InfoProprietario';
import { InfoArrendatario } from '../InfoArrendatario/infoArrendatario';
import InfoVeiculoLeitura from './infoVeiculoLeitura';

export const InfoVeiculos = ({
  dadosDeConsulta,
  carregarSolicitacaoAtual,
  setSpinning,
  tipoValidacao,
}) => dadosDeConsulta?.veiculos?.map((item, index) => (
      <Col key={index}>
        <InfoVeiculoLeitura
          item={item}
          carregarSolicitacaoAtual={carregarSolicitacaoAtual}
          setSpinning={setSpinning}
          tipoValidacao={tipoValidacao}
        />
        {item?.proprietario && (
          <InfoProprietario
            proprietario={item?.proprietario}
            carregarSolicitacaoAtual={carregarSolicitacaoAtual}
            setSpinning={setSpinning}
            tipoValidacao={tipoValidacao}
          />
        )}
        {item?.arrendatario && (
          <InfoArrendatario
            dadosArrend={item?.arrendatario}
            carregarSolicitacaoAtual={carregarSolicitacaoAtual}
            setSpinning={setSpinning}
            tipoValidacao={tipoValidacao}
          />
        )}
      </Col>
    ));
